import HeaderLayout from '../../../Layout/HeaderLayout';
import wiki from '../../../Services/wiki';
import SearchBar from '../../../Components/SearchBar/SearchBar';
import React from 'react';
import IWikiEntry from '../../../Models/IWiki';
import { PlainBox } from '../../../Components/PlainBox';
import './wikiMaster.scss';

interface IWikiMasterProps { }

interface IWikiMasterState {
    selectedWikiId?: string;
    wikis: { id: string, entry: IWikiEntry }[];
}

class WikiMaster extends React.Component<IWikiMasterProps, IWikiMasterState> {

    arrayFullWiki = Object.keys(wiki).map(id => ({ id, entry: wiki[id] })).sort((a, b) => a.entry.name.localeCompare(b.entry.name));
    topOfPageElement = document.getElementById('top-wiki');

    constructor(props: IWikiMasterProps) {
        super(props);
        this.state = {
            selectedWikiId: "",
            wikis: this.arrayFullWiki
        };
    }

    modifyWiki(text: string) {
        this.setState({ wikis: this.arrayFullWiki.filter(wiki => new RegExp(text.toLowerCase()).test(wiki.entry.name.toLowerCase())) });
    }

    scrollToTop() {
        if (this.topOfPageElement) {
            this.topOfPageElement.scrollIntoView({ behavior: 'auto' });
        }
        return true;
    }

    onSelectWikiClick(id: string) {
        this.setState({ selectedWikiId: id });
        this.scrollToTop();
    }

    render() {
        return (
            <div id="top-wiki">
                <HeaderLayout currentPage="wiki" hamburger={true} isMaster={true}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.66 100"><g><path fill="#fff" d="m76.21,95.46c-14.06,0-25.51-11.39-25.51-25.39s11.45-25.39,25.51-25.39c1.6,0,3.15.16,4.67.45v-25.12c0-1.14-.92-2.06-2.06-2.06h-2.87c-3.01-2.25-4.73-4.73-5.08-7.38-.38-2.84.89-5.29,1.64-6.45h2.75c1.14,0,2.06-.92,2.06-2.06s-.92-2.06-2.06-2.06H10.21C4.58,0,0,4.49,0,10v2.07c0,.37.07.73.11,1.09-.06.2-.11.4-.11.62v77.61c0,.25.06.48.14.7.01.03,0,.06.02.09.07.16.95,2.21,3.09,4.18.06.06.11.14.17.21.65.62,1.4,1.1,2.17,1.51.18.1.36.21.55.3,0,0,.02,0,.03.01,1.81.94,4.1,1.61,6.95,1.61.68,0,1.39-.04,2.14-.12h63.56c1.14,0,2.06-.92,2.06-2.06v-2.81c-1.51.28-3.07.45-4.67.45ZM10.21,17.94c-.3,0-.59-.04-.88-.09-1.12-.19-3.03-.84-4.41-2.92-.5-.85-.81-1.82-.81-2.87v-2.07c0-3.24,2.73-5.88,6.09-5.88h57.66c-.79,1.81-1.43,4.2-1.09,6.92.31,2.47,1.37,4.78,3.15,6.9H10.21Z" /><path fill="#fff" d="m76.21,46.74c-12.93,0-23.45,10.47-23.45,23.33s10.52,23.33,23.45,23.33,23.45-10.46,23.45-23.33-10.52-23.33-23.45-23.33Zm17.08,35.67h0c-.95.56-2.18.25-2.74-.7l-1.57-2.65c-.36-.61-1.01-.98-1.72-.98h-1.11c-.11,0-.21-.02-.31-.03-.91,3.52-3.76,6.26-7.33,7.02v-13.47h-4v13.47c-3.58-.76-6.42-3.5-7.33-7.02-.1.02-.2.03-.31.03h-1.11c-.71,0-1.36.37-1.72.98l-1.57,2.65c-.56.95-1.79,1.26-2.74.7h0c-.95-.56-1.26-1.79-.7-2.74l2.15-3.63c.72-1.22,2.03-1.96,3.44-1.96h2.25v-4.95h-3.39c-.71,0-1.36-.37-1.72-.98l-2.73-4.61c-.56-.95-.25-2.18.7-2.74.95-.56,2.18-.25,2.74.7l1.57,2.65c.36.61,1.01.98,1.72.98h1.11s.01,0,.02,0c.11-1.01.95-1.79,1.98-1.79h.33c0-4.03,3.29-7.31,7.32-7.31s7.31,3.28,7.31,7.31h.33c1.03,0,1.87.79,1.98,1.79,0,0,.01,0,.02,0h1.11c.71,0,1.36-.37,1.72-.98l1.57-2.65c.56-.95,1.79-1.26,2.74-.7h0c.95.56,1.26,1.79.7,2.74l-2.73,4.61c-.36.61-1.01.98-1.72.98h-3.39v4.95h3.39c.71,0,1.36.37,1.72.98l2.73,4.61c.56.95.25,2.18-.7,2.74Z" /></g></svg>
                    <span>Bestiaire</span>
                </HeaderLayout>

                {!this.state.selectedWikiId && <>
                    <SearchBar modifySearchedText={(text: string) => this.modifyWiki(text)} />

                    {this.state.wikis.map(wiki => {
                        return (
                            <div className="wiki-item" key={wiki.id} onClick={() => this.onSelectWikiClick(wiki.id)}>
                                {wiki.entry.name}
                            </div>
                        )
                    })}
                </>}

                {this.state.selectedWikiId && <>
                    <div className="wiki-details">
                        <div className="wiki-details-title">
                            <svg onClick={() => this.setState({ selectedWikiId: undefined })} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130.44"><g><path fill="#ec672a" d="m99.41,124.52c-18.35,0-33.28-14.86-33.28-33.12s14.93-33.12,33.28-33.12c2.08,0,4.11.21,6.09.58V26.09c0-1.48-1.2-2.68-2.68-2.68h-3.74c-3.92-2.93-6.17-6.17-6.62-9.62-.49-3.71,1.16-6.89,2.13-8.41h3.59c1.48,0,2.68-1.2,2.68-2.69s-1.2-2.68-2.68-2.68H13.32C5.98,0,0,5.85,0,13.04v2.7c0,.48.09.95.14,1.42-.08.26-.14.53-.14.81v101.24c0,.33.08.63.18.91.02.04,0,.08.02.12.09.21,1.24,2.89,4.03,5.45.08.08.14.19.22.27.84.81,1.82,1.43,2.83,1.98.23.14.48.27.72.4.01,0,.02.01.04.02,2.37,1.23,5.34,2.1,9.07,2.1.89,0,1.81-.05,2.79-.16h82.91c1.49,0,2.68-1.2,2.68-2.69v-3.66c-1.97.37-4,.58-6.09.58ZM13.32,23.41c-.39,0-.77-.06-1.14-.11-1.46-.25-3.95-1.1-5.75-3.81-.66-1.11-1.06-2.38-1.06-3.74v-2.7c0-4.23,3.57-7.67,7.95-7.67h75.21c-1.02,2.36-1.87,5.48-1.42,9.03.4,3.22,1.78,6.23,4.1,9H13.32Z" /><path fill="#ec672a" d="m99.41,60.97c-16.87,0-30.59,13.65-30.59,30.43s13.72,30.43,30.59,30.43,30.59-13.65,30.59-30.43-13.73-30.43-30.59-30.43Zm3.5,48.38h-19.87c-.56,0-1.01-.45-1.01-1.01v-5.13c0-.56.45-1.01,1.01-1.01h19.87c5.16,0,9.35-4.19,9.35-9.35s-4.19-9.35-9.35-9.35h-1.65s-3.32,0-3.32,0c-.65,0-1.1.66-.86,1.26l1.91,4.83c.09.22.02.47-.17.61-.19.14-.45.14-.63,0l-12.83-9.86c-.11-.08-.17-.2-.2-.33h0s0-.05,0-.07c0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.05,0-.07h0c.02-.13.09-.25.2-.33l12.83-9.86c.19-.14.45-.15.63,0,.19.14.26.39.17.61l-1.91,4.83c-.24.61.21,1.26.86,1.26h3.67s1.3,0,1.3,0c9.11,0,16.5,7.39,16.5,16.5s-7.39,16.5-16.5,16.5Z" /></g></svg>
                            <div className="wiki-details-title-text">
                                <PlainBox fill="#ec6526" />
                                <span>{wiki[this.state.selectedWikiId].name}</span>
                            </div>
                        </div>
                        {!!wiki[this.state.selectedWikiId].image && <img src={wiki[this.state.selectedWikiId].image} alt={"Image " + wiki[this.state.selectedWikiId].name.toLowerCase()} />}
                        <p>{wiki[this.state.selectedWikiId].description}</p>
                    </div>
                </>}
            </div>
        )
    };
}

export default WikiMaster;